const permissions = {
  listOffices: 'BO001',
  addOffices: 'BO002',
  editOffices: 'BO002',
  removeOffices: 'BO003'
};

export default permissions;
